import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';

export function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-text-dark text-center mb-6">
            Nearshoring
          </h1>
          <p className="text-center text-lg md:text-xl text-text-gray max-w-3xl mx-auto">
            Meet the team and learn what Pairing is about
          </p>
        </div>
      </section>

      {/* Team Started Coding Section */}
      <section className="py-16 bg-bg-gray-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark text-center mb-12">
            Our team of AI-assisted engineers
          </h2>

          {/* Team Grid */}
          <div className="flex flex-wrap justify-center gap-10 mb-16">
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/till.webp" alt="Till" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Till</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/max.webp" alt="Max" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Max</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/martin.webp" alt="Martin" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Martin</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/ayo.webp" alt="Eyoel" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Eyoel</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/tolu.webp" alt="Adam" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Adam</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/faizan.webp" alt="Nathan" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Nathan</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/silas.webp" alt="Silas" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Silas</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-48 h-48 rounded-full overflow-hidden mb-3 border border-gray-300">
                <img src="/team/diana.webp" alt="Anna" className="w-full h-full object-cover" />
              </div>
              <p className="text-text-dark font-semibold text-lg">Anna</p>
            </div>
          </div>
        </div>
      </section>

      {/* Remote Work Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark text-center mb-6">
            We are fully remote, by heart and by choice
          </h2>
          <p className="text-center text-lg text-text-gray max-w-3xl mx-auto mb-12">
            Our distributed team spans across 10 countries, working asynchronously to deliver exceptional results. Remote work isn't just a policy for us—it's our culture.
          </p>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary-blue bg-opacity-10 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-primary-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-text-dark mb-2">10 Countries</h3>
              <p className="text-text-gray">Team members across Europe, Africa, and Asia</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary-blue bg-opacity-10 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-primary-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-text-dark mb-2">Speak Your Language</h3>
              <p className="text-text-gray">German communication for clarity</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary-blue bg-opacity-10 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-primary-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-text-dark mb-2">Async Communication</h3>
              <p className="text-text-gray">Clear processes and documentation</p>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-16 bg-bg-gray-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="aspect-square max-w-md mx-auto">
                <img src="https://tillcarlos.com/images/till_shirt.jpg" alt="Till Carlos - Founder" className="w-full h-full object-cover rounded-full" />
              </div>
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-6">
                Meet the Founder
              </h2>
              <p className="text-lg text-text-gray mb-4">
                Till Carlos started as a freelancer for German and US clients
              </p>
              <ul className="space-y-4 text-text-gray">
                <li className="flex items-start">
                  <span className="text-primary-blue mr-3">•</span>
                  <span>Co-founded empuxa.com in Germany, building custom software solutions</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-blue mr-3">•</span>
                  <span>In 2013, moved to Asia and freelanced as a Ruby on Rails Senior Developer</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-blue mr-3">•</span>
                  <span>Recognized the talent gap and pivoted to building complete development teams</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-blue mr-3">•</span>
                  <span>Wrote thesis at XING AG and has been in software development for over 20 years</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Openness Section */}
      <section className="py-16 bg-bg-gray-light">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-6">
            Openness and Sharing
          </h2>
          <p className="text-lg text-text-gray mb-8">
            There was a point in time where we needed outsourced teams ourselves. So we went ahead and searched for companies to help us.
          </p>
          <h3 className="text-2xl font-bold text-text-dark mb-4">
            We wanted
          </h3>
          <p className="text-lg text-text-gray">
            A lot of smart Engineers starting staffing companies, but all of them lacked a unified process and transparency.
            So we built our company to address these points.
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark text-center mb-12">
            Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-blue bg-opacity-10 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-10 h-10 text-primary-blue" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </div>
              <h3 className="font-semibold text-text-dark mb-2">Quality</h3>
              <ul className="text-sm text-text-gray space-y-1">
                <li>Documentation</li>
                <li>Code quality</li>
                <li>Handover ready</li>
              </ul>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-primary-blue bg-opacity-10 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-10 h-10 text-primary-blue" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="font-semibold text-text-dark mb-2">Care</h3>
              <ul className="text-sm text-text-gray space-y-1">
                <li>No overtime</li>
                <li>Competitive salaries</li>
                <li>Remote work</li>
              </ul>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-primary-blue bg-opacity-10 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-10 h-10 text-primary-blue" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="font-semibold text-text-dark mb-2">Intelligence</h3>
              <ul className="text-sm text-text-gray space-y-1">
                <li>Developer growth</li>
                <li>Smart developers</li>
                <li>Smart clients</li>
              </ul>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-primary-blue bg-opacity-10 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-10 h-10 text-primary-blue" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clipRule="evenodd" />
                  <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                </svg>
              </div>
              <h3 className="font-semibold text-text-dark mb-2">Collaboration</h3>
              <ul className="text-sm text-text-gray space-y-1">
                <li>Flat hierarchy</li>
                <li>Critical thinking</li>
                <li>Communication</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-bg-gray-light">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-6">
            In the future: working with you is awesome
          </h2>
          <p className="text-lg text-text-gray mb-8">
            Is Pairing a company that resonates with you?
          </p>
          <Link
            to="/book"
            className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-blue hover:bg-dark-blue transition-colors"
          >
            Get Started Today
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
